import * as React from "react";
const SvgFiRrDrawPolygon = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-draw-polygon_svg__a)">
      <path
        fill="#062147"
        d="M20.5 17a3.5 3.5 0 0 0-1.411.297l-2.663-3.38c.363-.551.574-1.21.574-1.918s-.212-1.368-.575-1.919l2.636-3.391A3.504 3.504 0 0 0 24 3.499c0-1.93-1.57-3.5-3.5-3.5a3.51 3.51 0 0 0-3.162 2H6.662a3.51 3.51 0 0 0-3.162-2A3.505 3.505 0 0 0 0 3.5c0 1.393.819 2.599 2 3.162v10.677a3.51 3.51 0 0 0-2 3.162c0 1.93 1.57 3.5 3.5 3.5a3.51 3.51 0 0 0 3.162-2h10.677a3.51 3.51 0 0 0 3.162 2c1.93 0 3.5-1.57 3.5-3.5s-1.57-3.5-3.5-3.5zM4 17.036V6.964A3.51 3.51 0 0 0 6.964 4h10.072c.072.501.251.969.512 1.378L14.895 8.79a3.504 3.504 0 0 0-4.896 3.209 3.504 3.504 0 0 0 4.897 3.209l2.668 3.386a3.5 3.5 0 0 0-.53 1.405H6.964A3.51 3.51 0 0 0 4 17.036M15 12c0 .827-.673 1.5-1.5 1.5S12 12.827 12 12s.673-1.5 1.5-1.5 1.5.673 1.5 1.5m5.5-10c.827 0 1.5.673 1.5 1.5S21.327 5 20.5 5 19 4.327 19 3.5 19.673 2 20.5 2m-17 0C4.327 2 5 2.673 5 3.5S4.327 5 3.5 5 2 4.327 2 3.5 2.673 2 3.5 2m0 20c-.827 0-1.5-.673-1.5-1.5S2.673 19 3.5 19s1.5.673 1.5 1.5S4.327 22 3.5 22m17 0c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-draw-polygon_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrDrawPolygon;
